import { createContext } from 'react'

export type ContextType = {
    isFullWidth: boolean
    isMobileFullScreen: boolean
    toClose: () => void
}

export const Context = createContext<ContextType>({
    isFullWidth: false,
    isMobileFullScreen: false,
    toClose: () => {},
})
